<template>
    <svg class="icon icon-chart" @click="getMenu(id)">
        <use xlink:href="#icon-chart"></use>
    </svg>
</template>

<script>
import axios from 'axios';
import state from './../state.js';

export default {
    props: ['id', 'title'],

    data() {
        return {
            state
        };
    },

    methods: {
        getMenu(id) {
            axios
                .get('/recept/api/menu/' + id)
                .then((response) => {
                    this.state.charts = response.data;
                    this.state.chartHeader.title = this.title;
                    this.state.chartHeader.subtitle = 'Näringsvärden för alla dagar';
                })
                .catch((error) => {});
        }
    }
};
</script>
